export default "__VITE_ASSET__2$6Exqm3__"